// import { ChildrenStoreData } from "@parent-app/types";
import { ChildrenStoreData, ReportAbsencePostData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const fetchDailyDiaryDetails = async ({ child, date }: { child: ChildrenStoreData, date: string }): Promise<any> => {
    console.log("fetching daily diary details for :", child.childId, date);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/daily-dairy?date=${date}`).then((res) => {
        console.log("response from get daily diary  call : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchDailyDiaryNotes = async ({ child, date }: { child: ChildrenStoreData, date: string }): Promise<any> => {
    console.log("fetching daily diary notes for :", child.childId, date);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/daily-dairy/notes?date=${date}`).then((res) => {
        console.log("response from get daily diary notes call : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const updateNotesFromParents = async ({ child, date, notes }: { child: ChildrenStoreData, date: string, notes: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    return retryAxios.put(`/child/${child.childId}/daily-dairy/notes`, { notes, date }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

export const createAbsenceAPI = async ({ child, params }: { child: ChildrenStoreData, params: ReportAbsencePostData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.post(`/child/${child.childId}/absence`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};
